export const enumFromStringValue = <T>(enm: { [s: string]: T }, value?: string): T | undefined => {
  if (!value) {
    return undefined;
  }
  return (Object.values(enm) as string[]).includes(value) ? (value as T) : undefined;
};
